import { AxiosError } from "axios";
import { createLogic } from "redux-logic";
import {
  getMeFetch,
  getMeFetchSuccess,
  getMeFetchCancel,
  getMeFetchRejected,
} from "./logicActions";
import useMetricsPublisher from "../logging/useMetricsPublisher";
import { MetricType, MetricsState } from "../logging";
import { Api, http } from "../http";

const api = new Api(process.env.API_BASE_URL);

export const getMeUrl = "/api/auth/me";

/**
 * Async function that calls getMe endpoint and logs metrics for call.
 *
 * @param {MetricsState} metrics
 * @returns {Promise<any>}
 */
export const getMeFetchFn = async (metrics: MetricsState): Promise<any> => {
  const metricsPublisher = useMetricsPublisher(metrics, getMeFetch.toString());

  const httpMetric = new MetricType.HttpRequest(
    getMeFetch.toString()
  ).withMonitor();
  httpMetric.url = api.getEndpointUri(getMeUrl);

  try {
    const response = await http.get(api.getEndpointUri(getMeUrl), {
      withCredentials: true,
    });

    httpMetric.statusCode = response.status;
    httpMetric.statusText = response.statusText;
    httpMetric.setSuccess();

    return response.data;
  } catch (error) {
    console.error(error);

    httpMetric.setFailure();

    const httpError = error as AxiosError;
    if (httpError.response) {
      httpMetric.statusCode = httpError.response.status;
      httpMetric.statusText = httpError.response.statusText;
    }

    throw error;
  } finally {
    metricsPublisher.publish(httpMetric);
  }
};

export const getMeFetchLogic = createLogic({
  type: getMeFetch,
  cancelType: getMeFetchCancel,
  latest: true,

  processOptions: {
    dispatchReturn: true,
    successType: getMeFetchSuccess,
    failType: getMeFetchRejected,
  },

  process({ getState }) {
    const { metrics } = getState() as any;
    return getMeFetchFn(metrics);
  },
});

export default [getMeFetchLogic];
